<template>
  <div class="app-container">
    <div class="title-container">
      <div>商品评论列表</div>
    </div>
    <div class="filter-container">
      <el-input
        v-model="listQuery.goodsName"
        placeholder="商品名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.name"
        placeholder="用户昵称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.orderNo"
        placeholder="订单ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in statusArr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select
        v-model="listQuery.rating"
        placeholder="评分"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option v-for="item in 5" :key="item" :label="item" :value="item" />
      </el-select>
      <!-- <DataPicker
        @valueFunc="getPickerValueFunc"
        startPlaceholder="评论开始时间"
        endPlaceholder="评论截止时间"
      /> -->
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" @click="handleReset">重置</el-button>
      <el-button class="filter-item" type="primary" @click="showAddOrderReviewDialog"
        >新增订单评论</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
      row-key="id"
      :expand-row-keys="expandedIds"
      :tree-props="{ hasChildren: 'hasChildren' }"
      class="review-table"
      @expand-change="handleExpandChange"
    >
      <el-table-column type="expand" width="40" min-width="600">
        <template slot-scope="scope">
          <div v-if="scope.row.hasChildren" class="expand-content">
            <ReviewTree :data="scope.row.reviewReplies" :level="1" @delete="handleReplyDelete" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="用户信息" width="140" align="center">
        <template slot-scope="scope">
          <div class="user-info">
            <img
              v-if="scope.row.userImage"
              :src="scope.row.userImage"
              class="avatar"
              alt="用户头像"
            />
            <div v-else class="avatar-placeholder">
              <i class="el-icon-user"></i>
            </div>
            <span class="user-name">{{ scope.row.userName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="goodsName"
        label="商品名称"
        width="180"
      ></el-table-column>
      <el-table-column align="center" prop="userId" label="用户ID" width="100"></el-table-column>
      <el-table-column align="center" prop="rating" label="评分" width="100"></el-table-column>
      <el-table-column label="订单ID" align="center" prop="orderId" width="100"></el-table-column>
      <el-table-column class-name="status-col" label="状态" prop="status" align="center" width="80">
        <template slot-scope="scope">
          <el-tag
            :color="getValue(ORDER_STATUS_CSS, scope.row.status)"
            style="color: #FFFFFF"
            size="small"
          >
            {{ statusArr.find(item => item.value === scope.row.status)?.label || "-" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="评论内容" min-width="200" align="left">
        <template slot-scope="scope">
          <div class="content-cell">
            <span class="content-text">{{ scope.row.content }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="评价图片" align="center" width="140">
        <template slot-scope="scope">
          <div v-if="getImageList(scope.row.images).length > 0" class="image-list">
            <el-image
              v-for="(item, index) in getImageList(scope.row.images).slice(0, 3)"
              :key="index"
              :src="item"
              fit="cover"
              class="review-image"
              :preview-src-list="getImageList(scope.row.images)"
            />
            <span v-if="getImageList(scope.row.images).length > 3" class="image-more">
              +{{ getImageList(scope.row.images).length - 3 }}
            </span>
          </div>
          <span v-else class="no-image">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" prop="ctdate" width="160">
        <template slot-scope="scope">
          <span class="date-text">{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="center"
        label="更新时间"
        prop="mddate"
        width="160"
      >
        <template slot-scope="scope">
          <span class="date-text">{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" align="center" width="190" class-name="small-padding">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="mini"
            @click="handleDelete(scope.row)"
            icon="el-icon-delete"
            class="action-btn"
            >删除</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="showAuditDialog(scope.row)"
            icon="el-icon-check"
            class="action-btn"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="审核评论"
      :visible.sync="auditVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form :model="auditForm" label-width="80px">
        <el-form-item label="状态">
          <el-select v-model="auditForm.status" placeholder="请选择审核状态" style="width: 100%">
            <el-option
              v-for="item in statusArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="auditVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAuditSubmit">确定</el-button>
      </div>
    </el-dialog>

    <AddOrderReview :visible.sync="addReviewVisible" @success="handleAddReviewSuccess" />

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getAdminGoodsReviewsList, deleteReview, auditReview } from "@/api/goodsReview";
import { formatApiDate } from "@/utils/utils";
import { getValue } from "@/utils/enumUtile";
import { ORDER_STATUS_CSS } from "@/utils/enumUtileCss";
import DataPicker from "@/views/components/dataPicker.vue";
import AddOrderReview from "./addOrderReview.vue";
import ReviewTree from "./ReviewTree.vue";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    ORDER_STATUS_CSS() {
      return ORDER_STATUS_CSS;
    }
  },
  components: { DataPicker, AddOrderReview, ReviewTree },
  filters: {},
  data() {
    return {
      expandedIds: [],
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        name: null,
        goodsName: null,
        status: null
      },
      shipmentsVisible: false,
      orderInfo: {},
      shipmentsBtnLoading: false,
      auditRemark: "",
      auditVisible: false,
      addReviewVisible: false,
      auditForm: {
        id: null,
        status: null
      },
      goodsList: [],
      goodsListLoading: false,
      statusArr: [
        {
          label: "待审核",
          value: 0
        },
        {
          label: "已通过",
          value: 1
        },
        {
          label: "已拒绝",
          value: 2
        },
        {
          label: "已隐藏",
          value: 3
        }
      ]
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleExpandChange(row, expanded) {
      if (expanded) {
        const isExpanded = this.expandedIds.includes(row.id);
        if (isExpanded) {
          this.$set(this, "expandedIds", []);
        } else {
          this.$set(this, "expandedIds", [row.id]);
        }
      } else {
        this.$set(this, "expandedIds", []);
      }
    },
    handleDelete(item) {
      this.$confirm("确认删除该条评论吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteReview({ Id: item.id }).then(resp => {
          if (resp && resp.bizcode === 100) {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: resp.msg || "删除失败"
            });
          }
        });
      });
    },
    handleReplyDelete() {
      this.getList();
    },
    showAuditDialog(item) {
      this.auditForm.id = item.id;
      this.auditForm.status = item.status;
      this.auditVisible = true;
    },
    handleAuditSubmit() {
      if (this.auditForm.status === null) {
        this.$message({
          type: "warning",
          message: "请选择审核状态"
        });
        return;
      }
      auditReview({
        Id: this.auditForm.id,
        status: this.auditForm.status
      }).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.$message({
            type: "success",
            message: "审核成功"
          });
          this.auditVisible = false;
          this.getList();
        } else {
          this.$message({
            type: "error",
            message: resp.msg || "审核失败"
          });
        }
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleReset() {
      this.listQuery = {
        page: 1,
        pageSize: 20,
        name: null,
        goodsName: null,
        status: null,
        rating: null,
        orderNo: null,
        startTime: null,
        endTime: null
      };
      this.getList();
    },
    showAddOrderReviewDialog() {
      this.addReviewVisible = true;
    },
    handleAddReviewSuccess() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getAdminGoodsReviewsList(params)
        .then(response => {
          this.list = this.convertTreeData(response.data.entitys);
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    convertTreeData(data) {
      return data.map(item => {
        let reviewReplies = item.reviewReplies || [];
        const children = item.children || [];
        if (children.length > 0 && reviewReplies.length === 0) {
          reviewReplies = children;
        } else if (children.length > 0) {
          reviewReplies = [...reviewReplies, ...children];
        }
        return {
          ...item,
          hasChildren: reviewReplies.length > 0,
          reviewReplies: reviewReplies.length > 0 ? this.convertTreeData(reviewReplies) : []
        };
      });
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(value) {
      this.listQuery.startTime = value[0];
      this.listQuery.endTime = value[1];
    },
    /**
     * 将逗号分隔的图片字符串转换为数组，过滤空字符串
     * @param {string} imagesStr - 逗号分隔的图片URL字符串
     * @returns {string[]} - 图片URL数组
     */
    getImageList(imagesStr) {
      if (!imagesStr) return [];
      // 去除首尾引号（如果存在）
      let str = imagesStr;
      if (
        (str.startsWith('"') && str.endsWith('"')) ||
        (str.startsWith("'") && str.endsWith("'"))
      ) {
        str = str.slice(1, -1);
      }
      return str
        .split(",")
        .map(item => item.trim())
        .filter(item => item.length > 0 && item.startsWith("http"));
    }
  }
};
</script>
<style scoped lang="scss">
.title-container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;

  p {
    font-size: 14px;
    color: #909399;
    margin-top: 5px;
    font-weight: normal;
  }
}

.filter-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  flex-direction: row;

  .filter-item {
    margin-bottom: 0 !important;
    flex-shrink: 0;
  }
}

.review-table {
  .el-table__header-wrapper {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px 8px 0 0;

    th {
      color: #ffffff !important;
      font-weight: 600;
      background: transparent !important;
      border: none;
      text-align: center;
    }
  }

  .el-table__body-wrapper {
    border-radius: 0 0 8px 8px;
  }

  .el-table__row {
    transition: all 0.2s ease;

    &:hover {
      background: #fafbfc;
    }

    &.current-row {
      background: #e8f4fd;
    }
  }

  .el-table__cell {
    padding: 12px 8px;
    border-bottom: 1px solid #f2f6fc;
  }
}

.user-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #e4e7ed;
  }

  .avatar-placeholder {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 16px;
    border: 2px solid #e4e7ed;
  }

  .user-name {
    font-size: 12px;
    color: #606266;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.rating-stars {
  i {
    font-size: 14px;
    margin: 0 1px;
  }
}

.content-cell {
  .content-text {
    color: #606266;
    font-size: 13px;
    line-height: 1.5;
    word-break: break-all;
    display: inline-block;
  }

  .reply-count {
    color: #409eff;
    font-size: 12px;
    margin-left: 4px;
  }
}

.image-list {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;

  .review-image {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    cursor: pointer;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }

  .image-more {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 12px;
  }
}

.no-image {
  color: #c0c4cc;
  font-size: 12px;
}

.date-text {
  color: #909399;
  font-size: 12px;
}

.action-btn {
  margin-right: 6px;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
  }
}

.expand-content {
  padding: 16px;
  background: #fafbfc;
  border-radius: 8px;
  margin: -8px;
}

.comm_but_warp {
  margin-bottom: 5px;
}

.card_content {
  display: flex;
  flex-direction: column;
}
</style>
